import { customerHelper } from '@tweddle-se-team/common/constants'

const { CUSTOMER_IDS } = customerHelper

const getHeaderTitleByCustomer = {
  [CUSTOMER_IDS.SUBARU]: ({ year, model, modelType }) => {
    if (year && model && modelType) return `${year} ${model} ${modelType}`
    if (year && model) return `${year} ${model}`
    return null
  },
  [CUSTOMER_IDS.NORDICS]: ({ year, model }) => {
    if (year && model) return `${year} ${model}`
    return null
  }
}

const getMobileHeaderTitleByCustomer = {
  [CUSTOMER_IDS.SUBARU]: getHeaderTitleByCustomer[CUSTOMER_IDS.SUBARU],
  [CUSTOMER_IDS.NORDICS]: ({ year, model }) => {
    if (year && model) return `${model} ${year}`
    return null
  }
}

// Shared logic for header title and language label
export function getHeaderTitle({ year, model, modelType, customerId, t }) {
  const getTitle = getHeaderTitleByCustomer[customerId] || getHeaderTitleByCustomer[CUSTOMER_IDS.SUBARU]
  const title = getTitle({ year, model, modelType })
  if (title) return title

  return t('header_landing_title', 'Vehicle Resources')
}

export function getMobileHeaderTitle({ year, model, modelType, customerId, t }) {
  const getTitle = getMobileHeaderTitleByCustomer[customerId] || getMobileHeaderTitleByCustomer[CUSTOMER_IDS.SUBARU]
  const title = getTitle({ year, model, modelType })
  if (title) return title

  return t('header_landing_title', 'Vehicle Resources')
}

export function getLanguageLabel({ languages, locale, t }) {
  const language = languages?.[locale] || locale
  return t(language, language)
}
